import { render, staticRenderFns } from "./SelectReplacementNew.vue?vue&type=template&id=2346f1d8&"
import script from "./SelectReplacementNew.vue?vue&type=script&lang=js&"
export * from "./SelectReplacementNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectReplacementNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports